var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FiltersContainer",
    { attrs: { title: "Filters" }, on: { click: _vm.handleReset } },
    [
      _c("FormGroup", {
        attrs: {
          title: "File name",
          placeholder: "Enter file name",
          debounceTime: 500,
        },
        model: {
          value: _vm.fileName,
          callback: function ($$v) {
            _vm.fileName = $$v
          },
          expression: "fileName",
        },
      }),
      _c(
        "FormGroup",
        { attrs: { title: "Clients" } },
        [
          _c("ProjectsMultiselect", {
            attrs: { getcontainerStyle: "customWidthInput" },
            model: {
              value: _vm.selectedProjectsIds,
              callback: function ($$v) {
                _vm.selectedProjectsIds = $$v
              },
              expression: "selectedProjectsIds",
            },
          }),
        ],
        1
      ),
      _c(
        "FormGroup",
        { attrs: { title: "Companies" } },
        [
          _c("CompaniesMultiselect", {
            model: {
              value: _vm.selectedCompaniesIds,
              callback: function ($$v) {
                _vm.selectedCompaniesIds = $$v
              },
              expression: "selectedCompaniesIds",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }